module.exports = __webpack_public_path__ + "img/stu-no-submit.5a820c60.png";